import { SelectButton } from "primereact/selectbutton";

import "./style.scss";

const SelectButtonUI = (props) => <SelectButton {...props} className={`selectbutton-ui ${props.className}`} />;

export default SelectButtonUI;
